import React from 'react'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import * as css from './ProductTitle.css'
import classNames from 'classnames'

export const ProductTitle = React.memo<{ title }>(({ title }) => {
  return (
    <div className={classNames('clamp-two-lines', css['product-title'])}>
      <Typography variant={'h6'} align={'center'}>
        {title}
      </Typography>
    </div>
  )
})
